"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.CARD_OVERLAY_BUTTON = exports.CARD_OVERLAY_MORE_ICON = exports.CARD_OVERLAY = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../../../common/styles/vars"),
    CARD_OVERLAY = (0, _cxs["default"])({
  position: "absolute",
  left: 0,
  top: 0,
  height: "100%",
  width: "100%",
  background: "rgba(0, 0, 0, 0.75)",
  " > div.favourite-icon": {
    position: "absolute",
    left: "15px",
    top: "15px"
  }
});

exports.CARD_OVERLAY = CARD_OVERLAY;
var CARD_OVERLAY_MORE_ICON = (0, _cxs["default"])({
  height: "30px",
  width: "30px",
  position: "absolute",
  right: "15px",
  top: "15px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
});
exports.CARD_OVERLAY_MORE_ICON = CARD_OVERLAY_MORE_ICON;
var CARD_OVERLAY_BUTTON = (0, _cxs["default"])({
  position: "absolute",
  top: "43%",
  left: "50%",
  transform: "translate(-50%, 0%)",
  backgroundColor: "rgba(255, 255, 255, 0.35)",
  border: "1px solid ".concat(_vars.COLOURS.grey.athens.parthenon),
  borderRadius: "6px",
  height: "50px",
  cursor: "pointer",
  paddingLeft: "25px",
  paddingRight: "25px",
  ":hover": {
    backgroundColor: "rgba(255, 255, 255, 0.2)"
  }
});
exports.CARD_OVERLAY_BUTTON = CARD_OVERLAY_BUTTON;